import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { deserialize } from "utils/storeUtils";
import MorphedPackRepository from "repositories/MorphedPackRepository";

const initialState = {
  morphedPack: null,
};

const morphedPackSlice = createSlice({
  name: "morphedPack",
  initialState,
  reducers: {
    loadMorphedPack(state, { payload }) {
      state.morphedPack = deserialize(payload);
    },
  },
});

export const { actions } = morphedPackSlice;
export default morphedPackSlice.reducer;

export const useMorphedPackActions = () => {
  const dispatch = useDispatch();

  const loadMorphedPack = (slug) => {
    return MorphedPackRepository.show(slug).then(({ data }) => {
      dispatch(morphedPackSlice.actions.loadMorphedPack(data));
      return data;
    });
  };

  const generateStandardPhotos = (slug) => {
    return MorphedPackRepository.standardPhotos(slug).then(({ data }) => {
      return data;
    });
  };

  const getStatus = (slug) => {
    return MorphedPackRepository.status(slug).then(({ data }) => {
      return data;
    });
  };

  return { loadMorphedPack, generateStandardPhotos, getStatus };
};
